import { render } from "./switchModeDialog.vue?vue&type=template&id=38515928&scoped=true"
import script from "./switchModeDialog.vue?vue&type=script&lang=js"
export * from "./switchModeDialog.vue?vue&type=script&lang=js"

import "./switchModeDialog.vue?vue&type=style&index=0&id=38515928&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38515928"]])

export default __exports__